import { map } from 'lodash';
import type { IObjectivePossibleAdverseChangesToFinancialSituation } from './ObjectivePossibleAdverseChangesToFinancialSituation.interface';
import ObjectiveApplicant from './ObjectiveApplicant';
import ObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange from './ObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange';
import ObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments from './ObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments';
import { YesNoOption } from '../global/YesNoOption.enum';

export default class ObjectivePossibleAdverseChangesToFinancialSituation
  implements IObjectivePossibleAdverseChangesToFinancialSituation {
  planChangesToTheirFinancialCircumstances: YesNoOption;
  applicants: Array<ObjectiveApplicant>;
  natureOfPlannedChange: ObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange;
  applicantsIntendToMeetLoanRepayments: ObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments;

  static build = (data: IObjectivePossibleAdverseChangesToFinancialSituation) =>
    new ObjectivePossibleAdverseChangesToFinancialSituation(data);

  static blank = () => new ObjectivePossibleAdverseChangesToFinancialSituation();

  /**
   * Constructor
   * @param {IObjectivePossibleAdverseChangesToFinancialSituation} data
   */
  constructor(data?: IObjectivePossibleAdverseChangesToFinancialSituation) {
    this.planChangesToTheirFinancialCircumstances = YesNoOption.of(
      data?.planChangesToTheirFinancialCircumstances?.name ||
        data?.planChangesToTheirFinancialCircumstances?.toString()
    );
    this.applicants = map(data?.applicants, (obj) => new ObjectiveApplicant(obj));
    this.natureOfPlannedChange = new ObjectivePossibleAdverseChangesToFinancialSituationNatureOfPlannedChange(
      data?.natureOfPlannedChange
    );
    this.applicantsIntendToMeetLoanRepayments = new ObjectivePossibleAdverseChangesToFinancialSituationApplicantsIntendToMeetLoanRepayments(
      data?.applicantsIntendToMeetLoanRepayments
    );
  }
}
